import { render, staticRenderFns } from "./StockSnapshot.vue?vue&type=template&id=c419a0f6&scoped=true&"
import script from "./StockSnapshot.vue?vue&type=script&lang=js&"
export * from "./StockSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./StockSnapshot.vue?vue&type=style&index=0&id=c419a0f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c419a0f6",
  null
  
)

export default component.exports